<footer class="footer">
	<div class="container">
		<div class="row">
			<div class="col-md-4">
				<h4 class="title">Su di noi</h4>
				<p>
					Da più di vent’anni ORION costruisce alle porte di Firenze
					ambulanze e veicoli speciali che raccolgono l’apprezzamento
					e il favore di migliaia di soccorritori in Italia e nel mondo.
					Il gruppo Orion, della famiglia Meoni, ha raccolto la sfida
					più importante per il mondo sanitario: innovare le ambulanze,
					le automediche ed i veicoli speciali per l’emergenza affinché
					ogni soccorritore possa fare sempre meglio il proprio lavoro,
					e affinché ogni paziente si possa trovare nelle migliori condizioni
					possibili.
				</p>
			</div>

			<div class="col-md-4">
				<h4 class="title">ORION srl</h4>
				<p>
					Via Dei Gelsi14/A/B/C/D<br />
					50041 Calenzano (FI)<br />
					Italia<br />
					P.I. 04840260485<br />
					<br>
					Tel. +39 055 8839700 | info@orion-veicolispeciali.it
					<br />
				</p>
			</div>

			<div class="col-md-4">
				<h4 class="title">Social</h4>
				<p>
					<a href="https://www.facebook.com/orionveicolispeciali/" target="_blank"><i class="fab fa-facebook-square"></i></a>
					<a href="https://www.instagram.com/orionveicolispeciali/" target="_blank"><i class="fab fa-instagram-square"></i></a>
				</p>
			</div>
		</div>
	</div>
</footer>